// extracted by mini-css-extract-plugin
export default {"root":"profile-card_root__cDv3i","title":"profile-card_title__Vpdnw","content":"profile-card_content__5S56Y"};